module.exports = __webpack_public_path__ + "static/nav-logo-88e3fb1fb42127ea8fd22119d727c2f4.svg";